import React, { useEffect, useState } from 'react';
import fetcher from '../../utils/fetcher';
import useAlert from '../../contexts/alert';
import useInitFight, {
  FightPageMode,
  FightPageModeMarkers
} from '../../contexts/initFight';
import Loader from '../../components/general/loader';
import FightPagePick from './pick';
import FightPageBattle from './battle';
import FightPageResults from './results';

const FightPage = () => {
  const alert = useAlert();
  const [loading, setLoading] = useState(true);
  const { mode, goFight } = useInitFight();

  useEffect(() => {
    getUnfinishedFight();
  }, []);

  const getUnfinishedFight = () => {
    fetcher.fight
      .getUnfinished()
      .then((res) => {
        if (res) {
          // if have unfinished fight
          initFightWithId(res.nftId, res.bet, () => setLoading(false));
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        alert.showError(err);
        setLoading(false);
      });
  };

  const initFightWithId = (
    nftId: string,
    bet: number,
    callback: () => void
  ) => {
    fetcher.nft
      .getDetails(nftId)
      .then((response) => {
        goFight(response, bet, true);
      })
      .catch(alert.showError)
      .finally(() => callback());
  };

  if (loading) {
    return <Loader size={120} useAbsoluteWrapper color='white' />;
  }

  return <Content mode={mode} />;
};

interface ContentProps {
  mode: FightPageMode;
}

const Content = ({ mode }: ContentProps) => {
  switch (mode.marker) {
    case FightPageModeMarkers.PICK:
      return <FightPagePick />;
    case FightPageModeMarkers.BATTLE:
      return (
        <FightPageBattle
          nft={mode.nft}
          bet={mode.bet}
          straightToFight={mode.straightToFight}
        />
      );
    case FightPageModeMarkers.RESULTS:
      return (
        <FightPageResults
          fightId={mode.fightId}
          needCongrats={mode.needCongrats}
        />
      );
  }
};

export default FightPage;
